import { render, staticRenderFns } from "./GradingSettingCreate.vue?vue&type=template&id=32a39471"
import script from "../../controllers/grading_setting/grading-setting-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/grading_setting/grading-setting-create.js?vue&type=script&lang=js&external"
import style0 from "./GradingSettingCreate.vue?vue&type=style&index=0&id=32a39471&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports